<template>
  <div class="icon-web-alert" :class="{'icon-web-alert_safari': browserIsSafari}">

    <div class="pulse">
      <svg
        height="180"
        width="180"
        class="pulse__svg"
      >
        <circle class="pulse__circle" cx="90" cy="90" r="180" />
        <circle class="pulse__circle" cx="90" cy="90" r="180" />
        <circle class="pulse__circle" cx="90" cy="90" r="180" />
        <circle class="pulse__circle" cx="90" cy="90" r="180" />
        <circle class="pulse__circle" cx="90" cy="90" r="180" />
        <circle class="pulse__circle" cx="90" cy="90" r="180" />
      </svg>
    </div>

    <div class="text">
      <slot></slot>
    </div>
  </div>
</template>


<script>
import { isSafari } from 'src/utils/helpers';

export default {
  data: () => ({
    browserIsSafari: false,
  }),
  created() {
    if (isSafari()) {
      this.browserIsSafari = true;
    }
  },
};
</script>


<style lang="scss" scoped>
  $animationTime: 5s;
  .text {
    @include font(16px, $white-color2, bold);
    letter-spacing: 1.3px;
    position: absolute;
    top: 83px;
    left: 37px;
    text-transform: uppercase;
  }

  .remove-bg {
    .pulse__svg {
      background-image: none;
    }
    .pulse__circle {
      animation-duration: $animationTime;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-play-state: paused;
    }
    .icon-web-alert_safari {
      .pulse__svg {
        background-image: url('~src/assets/img/circle.png');
      }
      .pulse__circle {
        display: none;
      }
    }
    &:not(.card_is-touched) {
      &:hover {
        .pulse__circle {
          animation-play-state: running;
        }
      }
    }
  }

  .card_is-touched {
    &.card_show-effect {
      .pulse__circle {
        animation-play-state: running;
      }
    }
  }

  .pulse {
    position: relative;
    width:180px;
    height:180px;
  }

  .pulse__svg {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: block;
    transform-origin: center;
    border-radius: 50%;
    background-color: $red-color3;
    background-image: url('~src/assets/img/circle.png');
    background-position-y: 1px;
    box-shadow: 0px 10px 40px 0px $red-color11;
  }

  .pulse__circle {
    fill: none;
    stroke: $red-color12;
    stroke-width: 2px;
    transform-origin: center;
    transform: scale(0.2);
    opacity: 0;
    animation-name: pulse;
    animation-play-state: paused;
  }

  @keyframes pulse {
      0%   {
        opacity: 1;
        transform: scale(0.1);
    }
      100% {
        opacity: 0;
        transform: scale(1);
    }
  }

  .pulse__circle:nth-child(2){ animation-delay: $animationTime - 4; }
  .pulse__circle:nth-child(3){ animation-delay: $animationTime - 3; }
  .pulse__circle:nth-child(4){ animation-delay: $animationTime - 2; }
  .pulse__circle:nth-child(5){ animation-delay: $animationTime - 1; }
  .pulse__circle:nth-child(6){ animation-delay: $animationTime; }

</style>



// WEBPACK FOOTER //
// src/components/icons/IconWebAlert.vue